<div class="view-toolbar">
    <mat-form-field *ngIf="viewMode === 'cards'" class="search-field" appearance="outline">
        <input
            matInput
            placeholder="Search reports..."
            [(ngModel)]="searchValue"
            (input)="onSearchInput()"
        >
        <mat-icon matPrefix class="material-icons-outlined">search</mat-icon>
        <button
            *ngIf="searchValue"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch()"
            tabindex="-1"
            type="button"
        >
            <mat-icon class="material-icons-outlined">close</mat-icon>
        </button>
    </mat-form-field>

    <div class="k-flex-grow"></div>

    <mat-button-toggle-group class="view-toggle" [value]="viewMode" (change)="setViewMode($event.value)">
        <mat-button-toggle value="cards" aria-label="Card view" matTooltip="Card view">
            <mat-icon class="material-icons-outlined">grid_view</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="table" aria-label="Table view" matTooltip="Table view">
            <mat-icon class="material-icons-outlined">table_rows</mat-icon>
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<ng-container *ngIf="viewMode === 'cards'">
    <div class="report-cards-grid">
        <mat-card
            setColor
            [setColorRules]="[
                {
                    color: 'primaryColour',
                    style: 'border-color'
                },
                {
                    color: 'primaryColour',
                    style: 'background-color',
                    events: ['hover']
                }
            ]"
            *ngFor="let report of gridDataResult?.data"
            class="report-card mat-elevation-z0"
            (click)="goToRenderReport(report)"
        >
            <div class="icon-badge">
                <span setColor="primaryColour" class="material-icons-outlined">description</span>
            </div>

            <div class="text">
                <mat-card-title class="header">{{ report.name }}</mat-card-title>
                <mat-card-content *ngIf="report.description">{{ report.description }}</mat-card-content>
            </div>

            <mat-icon setColor="primaryColour" class="chevron material-icons-outlined">chevron_right</mat-icon>
        </mat-card>
    </div>

    <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="!isLoading && gridDataResult?.data?.length === 0" class="empty-state">
        No reports found.
    </div>

    <div *ngIf="gridDataResult?.total > pageSize" class="cards-pager">
        <button mat-icon-button [disabled]="!hasPrevPage" (click)="cardsPagePrev()" aria-label="Previous page">
            <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
        </button>
        <span>{{ pageStartIndex }}-{{ pageEndIndex }} of {{ gridDataResult.total }}</span>
        <button mat-icon-button [disabled]="!hasNextPage" (click)="cardsPageNext()" aria-label="Next page">
            <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
        </button>
    </div>
</ng-container>

<app-data-grid-comp
    *ngIf="viewMode === 'table'"
    [columns]="columns"
    hideActionButtons="true"
    [gridDataResult]="gridDataResult"
    [isLoading]="isLoading"
    [pageSize]="pageSize"
    [skip]="skip"
    [sortable]="{
        mode: 'single'
    }"
    [sort]="sort"
    [sortableColumns]="sortableColumns"
    searchable="true"
    (emitSearchEvent)="search($event)"
    [filterCategories]="filterCategories"
    (emitFilterEvent)="filterCallback($event)"
    category=""
    clickableRows="true"
    (emitPageChangeEvent)="pageChange($event)"
    (emitSortEvent)="sortChange($event)"
    (emitOpenDialogEvent)="goToRenderReport($event)"
></app-data-grid-comp>
